import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";


import { Panel, PanelBody, PanelHeader } from '../../header/panel/panel';

import TableView from "../Table/Table";

import { getDetailedReportByPTID, getSummaryReportByPTID, setFetchingReport } from '../../../redux/actions/ExportActions';
import { fetchAllProcessorTerminals } from '../../../redux/actions/DropdownActions';

import { setSnackbar } from "../../../redux/actions/SnackbarAction";

import { tableHeadings } from '../../../utils/constants';

import * as XLSX from 'xlsx';
import * as XLSXPopulate from 'xlsx-populate/browser/xlsx-populate';
import jsPDF from 'jspdf';

import addDays from 'date-fns/addDays';
import moment from 'moment';
import { Backdrop, CircularProgress } from '@mui/material';


const ProcessorReport = (props) => {

    const reportDropdown = [{ reportID: 1, reportName: 'Summary' }, { reportID: 2, reportName: 'Detailed' }]

    const [processorID, setProcessorID] = useState('')
    const [connectionID, setConnectionID] = useState('')
    const [processorTermID, setProcessorTermID] = useState('');
    const [reportType, setReportType] = useState('')
    const [isDate, setIsDate] = useState(false);
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')

    const [, setProcessorIDError] = useState(false)
    const [connectionIDError, setconnectionIDError] = useState(false)
    const [processorTermIDError, setprocessorTermIDError] = useState(false)
    const [, setStartError] = useState(false)
    const [, setEndError] = useState(false)
    const [reportError, setReportError] = useState(false)

    const [AllValueDD, setAllValueDD] = useState([])
    const [connectionDropdown, setConnectionDropdown] = useState([])
    const [processorTermDropdown, setProcessorTermDropdown] = useState([])

    const [minDate] = useState(new Date());
    const [maxDate, setMaxDate] = useState(new Date());
    const [toMinDate, setToMinDate] = useState(new Date());
    const [toMaxDate, setToMaxDate] = useState(new Date());

    const [maxDays, setMaxDays] = useState(31)

    useEffect(() => {
        setMaxDate(moment(new Date()).format('YYYY-MM-DD'))
        if (props.LOGINREDUCER.USER.role === 1) {
            setMaxDays(90)
        }
        props.fetchAllProcessorTerminals()
        setAllValueDD(props.DROPDOWNREDUCER.allProcessorTerminals)
        console.log('Use Effect : ' + AllValueDD)

    }, [])


    const handleChange = (event) => {
        let targetName = event.target.name
        let targetValue = event.target.value

        switch (targetName) {

            case 'reportType':
                if (targetValue) {
                    setReportError(false);
                    setReportType(targetValue)
                }
                break;
            case 'processorID':
                if (targetValue) {

                    setProcessorIDError(false)
                    setProcessorID(targetValue);
                    let processorConnections = props.DROPDOWNREDUCER.allProcessorTerminals.filter(processor => {
                        return String(processor.processorID) === String(targetValue) // eslint-fix: preserve loose-equality coercion
                    })
                    console.log('Connections : ' + processorConnections[0]?.processorConnections)
                    setConnectionDropdown(processorConnections[0]?.processorConnections)

                    console.log('Connection drop : ' + connectionDropdown)
                } else {
                    setConnectionDropdown([])
                }
                break;
            case 'connectionID':
                if (targetValue) {
                    setconnectionIDError(false);
                    setConnectionID(targetValue)
                    console.log('Connection ID : ' + targetValue)
                    let processorTerminal = connectionDropdown.filter(connection => {
                        return String(connection.connectionID) === String(targetValue) // eslint-fix: preserve loose-equality coercion
                    })
                    setProcessorTermDropdown(processorTerminal[0].processorTermID)
                    console.log(processorTermDropdown)

                    break;
                }
            // falls through
            case 'processorTermID':
                setprocessorTermIDError(false);
                setProcessorTermID(targetValue)
                break;

            case 'startDate':
                if (moment(new Date(targetValue)).isBefore(new Date())) {
                    setStartDate(targetValue);
                    setStartError(false)
                    if (moment(addDays(new Date(targetValue), maxDays)).isBefore(new Date())) {
                        setToMaxDate(moment(addDays(new Date(targetValue), maxDays)).format('YYYY-MM-DD'))
                    } else {
                        setToMaxDate(moment(new Date()).format('YYYY-MM-DD'))
                    }
                    setToMinDate(moment(addDays(new Date(targetValue), 1)).format('YYYY-MM-DD'))
                } else {
                    setStartError(true)
                }

                break;

            case 'endDate':

                if (moment(addDays(new Date(startDate), maxDays)).isAfter(new Date(targetValue))) {
                    setEndError(false)
                    setEndDate(targetValue);
                } else {
                    setEndError(true)
                }
                break;
            case 'daterange':
                setIsDate(event.target.checked)
                break;
            case 'reportType':
                setReportError(false);
                setReportType(targetValue)
                break;

            default:
                break;
        }
    }

    const handleSubmit = () => {
        let body = {}

        body.dateRange = isDate

        if (!reportType) {
            setReportError(true)
        } else {
            setReportError(false)
        }

        if (startDate) {
            body.startDate = startDate
        } else {
            setStartError(true)
        }
        if (isDate) {
            if (endDate) {
                body.endDate = endDate
            } else {

                setEndError(true)
            }
        }



        if (processorTermID && processorTermID === "All Terminals") {
            body.byConnectionID = true;
            body.connectionID = connectionID
        } else {
            body.byConnectionID = false;
            body.connectionID = connectionID
            body.terminalID = processorTermID
        }

        if (!connectionIDError && !processorTermIDError && !reportError) {


            if ((isDate && moment(addDays(new Date(startDate), maxDays)).isAfter(new Date(endDate))) || !isDate) {

                if (reportType && JSON.stringify(isDate) && startDate && Number(reportType) === 1) { // eslint-fix: preserve loose-equality coercion
                    props.setFetchingReport(true)
                    props.getSummaryReportByPTID(body)
                } else if (reportType && JSON.stringify(isDate) && startDate && Number(reportType) === 2) { // eslint-fix: preserve loose-equality coercion
                    props.setFetchingReport(true)
                    props.getDetailedReportByPTID(body)
                }
            } else {
                props.setSnackbar(true, 'error', 'Maximum Days Should be less than or Equal to 1 Month')
            }
        } else {
            props.setSnackbar(true, 'error', 'Please select all fields')

        }

    }


    const downloadXLSX = (ext) => {
        exportXLSX().then(url => {
            const downloadAnchorNode = document.createElement('a')
            downloadAnchorNode.setAttribute('href', url)
            downloadAnchorNode.setAttribute('download', `${Object.keys(props.EXPORTREDUCER.processorReportData).includes('reportDetails') ? 'Detailed Report' : 'Summary Report'}.${ext}`)
            downloadAnchorNode.click()
            downloadAnchorNode.remove()
        })
    }

    const downloadPDF = () => {
        const doc = new jsPDF();
        let title = `${Object.keys(props.EXPORTREDUCER.processorReportData).includes('reportDetails') ? 'Detailed Report' : 'Summary Report'}`
        // doc.text(title, 20, 10)
        doc.text(props.EXPORTREDUCER.processorReportData.headingName, 20, 10)
        let column, transactionCol = [
            { title: 'Total Transactions', field: 'transaction' },
            { title: 'Total Approval Count', field: 'approval' },
            { title: 'Approved Withdrawals', field: 'wthApprovalCount' },
            { title: 'Total Declined Count', field: 'decline' },
            { title: 'Total Amount', field: 'amount' },
            { title: 'Total Fee', field: 'fee' },
        ];
        let trasactionBody = []
        trasactionBody.push({
            transaction: props.EXPORTREDUCER.processorReportData.transactionTotals.totalTransactions,
            approval: props.EXPORTREDUCER.processorReportData.transactionTotals.totalApprovalCount,
            wthApprovalCount: props.EXPORTREDUCER.processorReportData.transactionTotals.totalWthApprovalCount,
            decline: props.EXPORTREDUCER.processorReportData.transactionTotals.totalDeclineCount,
            amount: props.EXPORTREDUCER.processorReportData.transactionTotals.totalAmount,
            fee: props.EXPORTREDUCER.processorReportData.transactionTotals.totalFee
        })
        if (Object.keys(props.EXPORTREDUCER.processorReportData).includes('reportDetails')) {
            column = [
                { title: 'Terminal ID', field: 'terminalID' },
                (props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 6) ? {
                    title: 'Processor Terminal ID', field: 'processorTermID'
                } : {},
                { title: 'Merchant', field: 'merchantName' },
                { title: 'Transaction Time', field: 'tranTime' },
                { title: 'Settled Date', field: 'businessDate' },
                { title: 'Transaction Type', field: 'tranType' },
                { title: 'Sequence Number', field: 'seqNumber' },
                { title: 'Amount', field: 'amount' },
                { title: 'Fee', field: 'fee' },
                { title: 'Pan', field: 'pan' },
                { title: 'Transaction Response', field: 'tranResponse' },
                { title: 'Statement Descriptor', field: 'bankStmtDescription' }
            ]
        } else {
            column = [
                { title: 'Terminal ID', field: 'terminalID' },
                (props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 6) ? {
                    title: 'Processor Terminal ID', field: 'processorTermID'
                } : {},
                { title: 'Merchant', field: 'merchantName' },
                { title: 'Date', field: 'transactionDate' },
                { title: 'Total Transactions', field: 'totalTransactions' },
                { title: 'Approved', field: 'numOfApprovals' },
                { title: 'Approved Withdrawals', field: 'numOfWthApprovals' },
                { title: 'Declined', field: 'numOfDeclines' },
                { title: 'Amount', field: 'amount' },
                { title: 'Fee', field: 'fee' },
                { title: 'Statement Descriptor', field: 'bankStmtDescription' }
            ]
        }
        let bodyData = []
        if (Object.keys(props.EXPORTREDUCER.processorReportData).includes('reportDetails')) {
            props.EXPORTREDUCER.processorReportData.reportDetails.forEach(data => {
                bodyData.push({
                    ...data
                })
            })
            // bodyData = props.EXPORTREDUCER.processorReportData.reportDetails
        } else {
            bodyData = props.EXPORTREDUCER.processorReportData.summaryDetails
        }

        doc.autoTable({
            theme: 'grid',
            columns: transactionCol.map(col => ({ ...col, dataKey: col.field })),
            body: trasactionBody
        })

        doc.autoTable({
            theme: 'grid',
            columns: column.map(col => ({ ...col, dataKey: col.field })),
            body: bodyData
        })
        doc.save(`${title}.pdf`)
    }

    const exportXLSX = () => {
        const title = [{ A: props.EXPORTREDUCER.processorReportData.headingName }]

        let table1 = [{
            A: 'Total Transactions',
            B: 'Total Approval Count',
            C: 'Total Approved With Count',
            D: 'Total Declined Count',
            E: 'Total Amount',
            F: "Total Fee"
        }]
        let table2

        if (Object.keys(props.EXPORTREDUCER.processorReportData).includes('reportDetails')) {

            if (props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 6)
                table2 = [{
                    A: 'Terminal ID',
                    B: 'Processor Terminal ID',
                    C: 'Merchant',
                    D: 'Transaction Time',
                    E: 'Transaction Date',
                    F: 'Settled Date',
                    G: 'Transaction Type',
                    H: 'Sequence Number',
                    I: 'Amount',
                    J: 'Fee',
                    K: 'Pan',
                    L: 'Transaction Response',
                    M: 'Statement Descriptor'
                }]
            else {
                table2 = [{
                    A: 'Terminal ID',
                    B: 'Merchant',
                    C: 'Transaction Time',
                    D: 'Settled Date',
                    E: 'Transaction Type',
                    F: 'Sequence Number',
                    G: 'Amount',
                    H: 'Fee',
                    I: 'Pan',
                    J: 'Transaction Response',
                    K: 'Statement Descriptor'
                }]
            }
        } else {
            if (props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 6) {
                table2 = [{
                    A: 'Terminal ID',
                    B: 'Processor Terminal ID',
                    C: 'Merchant',
                    D: 'Date',
                    E: 'Total Transactions',
                    F: 'Total Approved',
                    G: 'Approved withdrawals',
                    H: 'Declined',
                    I: 'Amount',
                    J: 'Fee',
                    K: 'Statement Descriptor'
                }]

            } else {
                table2 = [{
                    A: 'Terminal ID',
                    B: 'Merchant',
                    C: 'Date',
                    D: 'Total Transactions',
                    E: 'Total Approved',
                    F: 'Approved withdrawals',
                    G: 'Declined',
                    H: 'Amount',
                    I: 'Fee',
                    J: 'Statement Descriptor'
                }]

            }

        }

        table1.push({
            A: props.EXPORTREDUCER.processorReportData.transactionTotals.totalTransactions,
            B: props.EXPORTREDUCER.processorReportData.transactionTotals.totalApprovalCount,
            C: props.EXPORTREDUCER.processorReportData.transactionTotals.totalWthApprovalCount,
            D: props.EXPORTREDUCER.processorReportData.transactionTotals.totalDeclineCount,
            E: props.EXPORTREDUCER.processorReportData.transactionTotals.totalAmount,
            F: props.EXPORTREDUCER.processorReportData.transactionTotals.totalFee
        })

        if (Object.keys(props.EXPORTREDUCER.processorReportData).includes('reportDetails')) {
            props.EXPORTREDUCER.processorReportData.reportDetails.forEach(data => {
                // let dt = moment(data.tranTime).format('MM-DD-YYYY HH:mm:ss')
                if (props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 6) {
                    table2.push({
                        A: data.terminalID,
                        B: data.processorTermID,
                        C: data.merchantName,
                        D: data.tranTime,
                        E: data.tranDate,
                        F: data.businessDate,
                        G: data.tranType,
                        H: data.seqNumber,
                        I: data.amount,
                        J: data.fee,
                        K: data.pan,
                        L: data.tranResponse,
                        M: data.bankStmtDescription

                    })

                } else {
                    table2.push({
                        A: data.terminalID,
                        B: data.merchantName,
                        C: data.tranTime,
                        D: data.businessDate,
                        E: data.tranType,
                        F: data.seqNumber,
                        G: data.amount,
                        H: data.fee,
                        I: data.pan,
                        J: data.tranResponse,
                        K: data.bankStmtDescription
                    })

                }
            })
        } else {
            props.EXPORTREDUCER.processorReportData.summaryDetails.forEach(data => {
                if (props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 6) {
                    table2.push({
                        A: data.terminalID,
                        B: data.processorTermID,
                        C: data.merchantName,
                        D: data.transactionDate,
                        E: data.totalTransactions,
                        F: data.numOfApprovals,
                        G: data.numOfWthApprovals,
                        H: data.numOfDeclines,
                        I: data.amount,
                        J: data.fee,
                        K: data.bankStmtDescription
                    })
                } else {
                    table2.push({
                        A: data.terminalID,
                        B: data.merchantName,
                        C: data.transactionDate,
                        D: data.totalTransactions,
                        E: data.numOfApprovals,
                        F: data.numOfWthApprovals,
                        G: data.numOfDeclines,
                        H: data.amount,
                        I: data.fee,
                        J: data.bankStmtDescription
                    })
                }

            })
        }


        let finalTable = [{ A: Object.keys(props.EXPORTREDUCER.processorReportData).includes('reportDetails') ? 'Detailed Report' : 'Summary Report', B: title }].concat([""]).concat([""]).concat([""]).concat(table1).concat([""]).concat([""]).concat(table2)
        // let finalData = [{ A: $title }].concat([""]).concat([""]).concat([""]).concat(table1).concat([""]).concat([""]).concat(table2)
        let finalData = [...title, ...finalTable]
        const wb = XLSX.utils.book_new();

        const sheet = XLSX.utils.json_to_sheet(finalData, { skipHeader: true })

        XLSX.utils.book_append_sheet(wb, sheet, Object.keys(props.EXPORTREDUCER.processorReportData).includes('reportDetails') ? 'Detailed Report' : 'Summary Report')

        const workbookBlob = workbook2blob(wb)
        const dataInfo = {
            titleCell: "A2",
            titleRange: "A1:I2",
            tBodyRange: `A5:J${finalData.length}`
        }
        return addStyles(workbookBlob, dataInfo)
    }

    const addStyles = (workbookBlob, dataInfo) => {
        return XLSXPopulate.fromDataAsync(workbookBlob).then(wb => {
            wb.sheets().forEach(sheet => {
                sheet.column('A').width(15)
                sheet.column('B').width(30)
                sheet.column('C').width(30)
                sheet.column('D').width(15)
                sheet.column('E').width(20)
                sheet.column('F').width(15)
                sheet.column('G').width(20)
                sheet.column('H').width(15)
                sheet.column('I').width(20)
                sheet.column('J').width(20)
                sheet.column('K').width(20)
                sheet.range(dataInfo.titleRange).merged(true).style({
                    bold: true,
                    horizontalAlignment: "center",
                    verticalAlignment: "center"
                })
                sheet.range(dataInfo.tBodyRange).style({
                    horizontalAlignment: "center",
                })
            })
            return wb.outputAsync().then(wbb => URL.createObjectURL(wbb));
        })
    }

    const workbook2blob = (wb) => {
        const params = {
            bookType: 'xlsx',
            type: "binary"
        }
        const wboutput = XLSX.write(wb, params)
        const blob = new Blob([s2ab(wboutput)], {
            type: 'application/octet-stream'
        })

        return blob
    }

    const s2ab = (data) => {
        const buffer = new ArrayBuffer(data.length)
        const view = new Uint8Array(buffer)
        for (let i = 0; i !== data.length; i++) {
            view[i] = data.charCodeAt(i);
        }
        return buffer;
    }


    let EXPORTFORM = (


        <Panel>

            <PanelHeader>


                <div className="row mb-0">

                    <div className="col-xl-8">
                        Export Report
                    </div>
                    <div className="col-xl-4">
                    </div>
                </div>


            </PanelHeader>

            <PanelBody>

                <>
                    <div className="row mb-3">
                        <div className="col-xl-12">
                            <select className="form-select"
                                onChange={handleChange}
                                name='reportType'
                                value={reportType ? reportType : ''}
                            >

                                <option value=''>Select Report Type</option>
                                {reportDropdown.map((option) => (
                                    <option key={option.reportID} value={option.reportID}>
                                        {option.reportName}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-xl-12">
                            <select className="form-select"
                                value={processorID ? processorID : ''}
                                onChange={handleChange}
                                name='processorID'


                            >
                                <option value=''>Select Processor</option>
                                {AllValueDD?.map((option) => (
                                    <option key={option.processorID} value={option.processorID}>
                                        {option.processorName}
                                    </option>
                                ))}

                            </select>
                        </div>
                    </div>


                    <div className="row mb-3">
                        <div className="col-xl-12">
                            <select className="form-select"

                                value={connectionID ? connectionID : ''}
                                onChange={handleChange}
                                name='connectionID'


                            >
                                <option value=''>Select Connection</option>
                                {connectionDropdown?.map((option) => (
                                    <option key={option.connectionID} value={option.connectionID}>
                                        {option.connectionName}
                                    </option>
                                ))}

                            </select>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-xl-12">
                            <select className="form-select"
                                value={processorTermID ? processorTermID : ''}
                                onChange={handleChange}
                                name='processorTermID'


                            >
                                <option value=''>Select Processor Terminal</option>
                                <option key={"All Terminals"} value={"All Terminals"}>
                                    {"All Terminals"}
                                </option>
                                {processorTermDropdown?.map((option) => (
                                    <option key={option} value={option}>
                                        {option}
                                    </option>
                                ))}

                            </select>
                        </div>
                    </div>
                </>


                <div className="row mb-3">

                    <div className="col-xl-12">
                        <label className="form-check-label" >
                            <b>Enable Date Range</b>&nbsp;&nbsp;&nbsp;
                            <input className="form-check-input" type="checkbox" checked={isDate} onChange={handleChange} name='daterange' >
                            </input>
                        </label>

                    </div>

                </div>
                <div className="row mb-3">
                    <div className="col-xl-12">
                        <label className="form-check-label" >
                            <b>{isDate ? 'Start ' : ''} Date</b>
                        </label>
                        <input
                            max={maxDate}
                            min={minDate}
                            defaultValue={maxDate}
                            // value = {startDate ? startDate : ''}
                            id="startDate"
                            label="Start Date"
                            type="date"
                            onChange={handleChange}
                            name="startDate"
                            className="form-control fs-13px"
                        ></input>
                    </div>
                </div>

                {isDate ? <div className="row mb-3">
                    <div className="col-xl-12">
                        <label className="form-check-label" >
                            <b>End Date</b>
                        </label>

                        <input
                            defaultValue={endDate}
                            min={toMinDate}
                            max={toMaxDate}
                            id="endDate"
                            label="End Date"
                            type="date"
                            onChange={handleChange}
                            name="endDate"
                            className="form-control fs-13px"
                        ></input>
                    </div>
                </div> : null}


                <button className="btn btn-primary w-100px me-5px" onClick={handleSubmit}>Run Report</button>

            </PanelBody>

        </Panel>

    )


    return (
        <div className="row mb-3">
            {
                props.EXPORTREDUCER.fetching ?
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={props.EXPORTREDUCER.fetching}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop> : null
            }

<div className="col-xl-2">


            {EXPORTFORM}

</div>
<div className="col-xl-10">

            <Panel>

                <PanelHeader>

                    <div className="row mb-0">

                        <div className="col-xl-6">
                            <h4>Report</h4>
                        </div>

                        <div className="col-xl-2">
                            <button className="btn btn-sm btn-primary d-block w-40 btn-lg h-30px fs-09px" onClick={() => downloadXLSX('xlsx')}>Download As Excel</button>

                        </div>

                        <div className="col-xl-2">
                            <button className="btn btn-sm btn-primary d-block w-40 btn-lg h-30px fs-09px" onClick={() => downloadXLSX('csv')}>Download As CSV</button>

                        </div>
                        <div className="col-xl-2">
                            <button className="btn btn-sm btn-primary d-block w-40 btn-lg h-30px fs-09px" onClick={downloadPDF}>Download As PDF</button>
                            {/* <Button fullWidth onClick={downloadPDF} >Download as PDF</Button> */}

                        </div>

                    </div>



                </PanelHeader>

                <PanelBody>
                    <h4>Report - {props.EXPORTREDUCER.processorReportData ? props.EXPORTREDUCER.processorReportData.headingName : ''}</h4>
                </PanelBody>


                {reportType === 1 ? <TableView height={570} count={12} headings={tableHeadings.summaryReportAdmin} data={props.EXPORTREDUCER.processorReportData?.summaryDetails ? props.EXPORTREDUCER.processorReportData?.summaryDetails : []} />
                    : <TableView height={570} count={12} headings={tableHeadings.detailedReportAdmin} data={props.EXPORTREDUCER.processorReportData?.reportDetails ? props.EXPORTREDUCER.processorReportData?.reportDetails : []} />}

                <PanelBody>

                    <div className="row">

                        <div className="col-md-3">
                            <label className="col-md-12"><h5><b>Total Transactions :&nbsp;&nbsp;</b>{props.EXPORTREDUCER.processorReportData?.transactionTotals?.totalTransactions?.toLocaleString()}</h5></label>
                        </div>
                        <div className="col-md-3">
                            <label className="col-md-12"><h5><b>Total Approved :&nbsp;&nbsp;</b>{props.EXPORTREDUCER.processorReportData?.transactionTotals?.totalApprovalCount?.toLocaleString()}</h5></label>
                        </div>
                        <div className="col-md-3">
                            <label className="col-md-12"><h5><b>Approved Withdrawals :&nbsp;&nbsp;</b>{props.EXPORTREDUCER.processorReportData?.transactionTotals?.totalWthApprovalCount?.toLocaleString()}</h5></label>
                        </div>
                        <div className="col-md-3">
                            <label className="col-md-12"><h5><b>Total Declined :&nbsp;&nbsp;&nbsp;</b>{props.EXPORTREDUCER.processorReportData?.transactionTotals?.totalDeclineCount?.toLocaleString()}</h5></label>
                        </div>

                        <div className="col-md-3">
                            <label className="col-md-12"><h5><b>Amount : &nbsp;&nbsp;&nbsp; $ </b>{props.EXPORTREDUCER.processorReportData?.transactionTotals?.totalAmount?.toLocaleString()}</h5></label>
                        </div>

                        <div className="col-md-3">
                            <label className="col-md-12"><h5><b>Fee :&nbsp;&nbsp;&nbsp; $ </b>{props.EXPORTREDUCER.processorReportData?.transactionTotals?.totalFee?.toLocaleString()}</h5></label>
                        </div>

                    </div>

                </PanelBody>


            </Panel>



            </div>


            </div>
    )
}
function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchAllProcessorTerminals,
    setSnackbar,
    getDetailedReportByPTID,
    setFetchingReport,
    getSummaryReportByPTID,
}
export default connect(mapStateToProps, mapDispatchToProps)(ProcessorReport);